"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.agricultureOpsEntityKeySchema = exports.agricultureOpsBootstrapSchema = exports.agricultureOpsWeatherSchema = exports.agricultureOpsReportCategorySchema = exports.agricultureOpsReportDefinitionSchema = exports.agricultureOpsTimesheetRecordSchema = exports.agricultureOpsWorkerRecordSchema = exports.agricultureOpsWorkerTrainingRecordSchema = exports.agricultureOpsWorkerCertificationSchema = exports.agricultureOpsProjectRecordSchema = exports.agricultureOpsProjectRiskSchema = exports.agricultureOpsProjectMilestoneSchema = exports.agricultureOpsWorkOrderRecordSchema = exports.agricultureOpsWorkOrderActivitySchema = exports.agricultureOpsWorkOrderAttachmentSchema = exports.agricultureOpsWorkOrderTaskSchema = exports.agricultureOpsPoiRecordSchema = exports.agricultureOpsCropRecordSchema = exports.agricultureOpsCropMarketEntrySchema = exports.agricultureOpsCropHarvestRecordSchema = exports.agricultureOpsCropTreatmentLogSchema = exports.agricultureOpsCropConditionLogSchema = exports.agricultureOpsGeofenceRecordSchema = exports.agricultureOpsNotificationRuleSchema = exports.agricultureOpsGeofenceZoneSchema = exports.agricultureOpsEquipmentRecordSchema = exports.agricultureOpsMaintenanceEntrySchema = exports.agricultureOpsLivestockRecordSchema = exports.agricultureOpsLivestockHealthLogSchema = exports.agricultureOpsLivestockMovementSchema = exports.agricultureOpsMapPointSchema = exports.agricultureOpsPersonSchema = exports.agricultureOpsAlertSchema = exports.agricultureOpsMetricSchema = exports.agricultureOpsTimelineEntrySchema = exports.agricultureOpsCommentSchema = exports.agricultureOpsCommentKindSchema = exports.agricultureOpsToneSchema = void 0;
const zod_1 = require("zod");
exports.agricultureOpsToneSchema = zod_1.z.enum([
    "emerald",
    "amber",
    "rose",
    "cyan",
    "violet",
    "slate",
]);
exports.agricultureOpsCommentKindSchema = zod_1.z.enum([
    "comment",
    "action",
    "system",
]);
exports.agricultureOpsCommentSchema = zod_1.z
    .object({
    id: zod_1.z.string(),
    author: zod_1.z.string(),
    message: zod_1.z.string(),
    createdAt: zod_1.z.string(),
    kind: exports.agricultureOpsCommentKindSchema.default("comment"),
})
    .strict();
exports.agricultureOpsTimelineEntrySchema = zod_1.z
    .object({
    id: zod_1.z.string(),
    at: zod_1.z.string(),
    title: zod_1.z.string(),
    detail: zod_1.z.string().optional(),
    actorName: zod_1.z.string(),
    tone: exports.agricultureOpsToneSchema.optional(),
})
    .strict();
exports.agricultureOpsMetricSchema = zod_1.z
    .object({
    label: zod_1.z.string(),
    value: zod_1.z.string(),
    helper: zod_1.z.string().optional(),
    tone: exports.agricultureOpsToneSchema.optional(),
})
    .strict();
exports.agricultureOpsAlertSchema = zod_1.z
    .object({
    id: zod_1.z.string(),
    title: zod_1.z.string(),
    message: zod_1.z.string(),
    severity: zod_1.z.enum(["info", "warning", "critical"]),
    createdAt: zod_1.z.string(),
})
    .strict();
exports.agricultureOpsPersonSchema = zod_1.z
    .object({
    name: zod_1.z.string(),
    role: zod_1.z.string(),
    contact: zod_1.z.string(),
    email: zod_1.z.string().optional(),
    avatarInitials: zod_1.z.string(),
    organization: zod_1.z.string().optional(),
})
    .strict();
exports.agricultureOpsMapPointSchema = zod_1.z
    .object({
    lat: zod_1.z.number(),
    lng: zod_1.z.number(),
    label: zod_1.z.string().optional(),
    kind: zod_1.z
        .enum(["marker", "vehicle", "livestock", "poi", "sensor"])
        .optional(),
})
    .strict();
exports.agricultureOpsLivestockMovementSchema = zod_1.z
    .object({
    id: zod_1.z.string(),
    at: zod_1.z.string(),
    location: zod_1.z.string(),
    event: zod_1.z.string(),
    distanceKm: zod_1.z.number(),
})
    .strict();
exports.agricultureOpsLivestockHealthLogSchema = zod_1.z
    .object({
    id: zod_1.z.string(),
    at: zod_1.z.string(),
    status: zod_1.z.string(),
    treatment: zod_1.z.string().optional(),
    owner: zod_1.z.string(),
    note: zod_1.z.string(),
})
    .strict();
exports.agricultureOpsLivestockRecordSchema = zod_1.z
    .object({
    id: zod_1.z.string(),
    tag: zod_1.z.string(),
    type: zod_1.z.string(),
    breed: zod_1.z.string(),
    count: zod_1.z.number(),
    health: zod_1.z.string(),
    trackerId: zod_1.z.string(),
    trackerStatus: zod_1.z.string(),
    paddock: zod_1.z.string(),
    lastSeen: zod_1.z.string(),
    description: zod_1.z.string(),
    farmer: exports.agricultureOpsPersonSchema,
    assignedDriver: exports.agricultureOpsPersonSchema.nullable().optional(),
    transportUnit: zod_1.z.string().nullable().optional(),
    lastHealthCheck: zod_1.z.string(),
    metrics: zod_1.z.array(exports.agricultureOpsMetricSchema),
    telematics: zod_1.z.array(exports.agricultureOpsMetricSchema),
    alerts: zod_1.z.array(exports.agricultureOpsAlertSchema),
    movementHistory: zod_1.z.array(exports.agricultureOpsLivestockMovementSchema),
    healthLogs: zod_1.z.array(exports.agricultureOpsLivestockHealthLogSchema),
    timeline: zod_1.z.array(exports.agricultureOpsTimelineEntrySchema),
    comments: zod_1.z.array(exports.agricultureOpsCommentSchema),
    polygon: zod_1.z.array(exports.agricultureOpsMapPointSchema),
    markers: zod_1.z.array(exports.agricultureOpsMapPointSchema),
    linkedWorkOrderIds: zod_1.z.array(zod_1.z.string()),
    linkedProjectIds: zod_1.z.array(zod_1.z.string()),
})
    .strict();
exports.agricultureOpsMaintenanceEntrySchema = zod_1.z
    .object({
    id: zod_1.z.string(),
    at: zod_1.z.string(),
    title: zod_1.z.string(),
    cost: zod_1.z.number(),
    note: zod_1.z.string(),
    owner: zod_1.z.string(),
})
    .strict();
exports.agricultureOpsEquipmentRecordSchema = zod_1.z
    .object({
    id: zod_1.z.string(),
    name: zod_1.z.string(),
    type: zod_1.z.string(),
    hoursRun: zod_1.z.number(),
    utilization: zod_1.z.number(),
    fuelUsedL: zod_1.z.number(),
    lastService: zod_1.z.string(),
    nextService: zod_1.z.string(),
    status: zod_1.z.string(),
    vehicleId: zod_1.z.string().optional(),
    operator: exports.agricultureOpsPersonSchema.nullable(),
    description: zod_1.z.string(),
    location: zod_1.z.string(),
    fuelEfficiency: zod_1.z.string(),
    telemetry: zod_1.z.array(exports.agricultureOpsMetricSchema),
    liveSignals: zod_1.z.array(exports.agricultureOpsMetricSchema),
    maintenanceHistory: zod_1.z.array(exports.agricultureOpsMaintenanceEntrySchema),
    alerts: zod_1.z.array(exports.agricultureOpsAlertSchema),
    timeline: zod_1.z.array(exports.agricultureOpsTimelineEntrySchema),
    comments: zod_1.z.array(exports.agricultureOpsCommentSchema),
    markers: zod_1.z.array(exports.agricultureOpsMapPointSchema),
})
    .strict();
exports.agricultureOpsGeofenceZoneSchema = zod_1.z
    .object({
    id: zod_1.z.string(),
    name: zod_1.z.string(),
    crop: zod_1.z.string().optional(),
    livestock: zod_1.z.string().optional(),
    area: zod_1.z.string(),
    purpose: zod_1.z.string(),
})
    .strict();
exports.agricultureOpsNotificationRuleSchema = zod_1.z
    .object({
    id: zod_1.z.string(),
    label: zod_1.z.string(),
    enabled: zod_1.z.boolean(),
})
    .strict();
exports.agricultureOpsGeofenceRecordSchema = zod_1.z
    .object({
    id: zod_1.z.string(),
    externalId: zod_1.z.string(),
    name: zod_1.z.string(),
    type: zod_1.z.string(),
    status: zod_1.z.string(),
    area: zod_1.z.string(),
    perimeter: zod_1.z.string(),
    owner: exports.agricultureOpsPersonSchema,
    description: zod_1.z.string(),
    alerts: zod_1.z.array(exports.agricultureOpsAlertSchema),
    zones: zod_1.z.array(exports.agricultureOpsGeofenceZoneSchema),
    notificationRules: zod_1.z.array(exports.agricultureOpsNotificationRuleSchema),
    timeline: zod_1.z.array(exports.agricultureOpsTimelineEntrySchema),
    comments: zod_1.z.array(exports.agricultureOpsCommentSchema),
    polygon: zod_1.z.array(exports.agricultureOpsMapPointSchema),
    markers: zod_1.z.array(exports.agricultureOpsMapPointSchema),
})
    .strict();
exports.agricultureOpsCropConditionLogSchema = zod_1.z
    .object({
    id: zod_1.z.string(),
    at: zod_1.z.string(),
    condition: zod_1.z.string(),
    note: zod_1.z.string(),
    owner: zod_1.z.string(),
})
    .strict();
exports.agricultureOpsCropTreatmentLogSchema = zod_1.z
    .object({
    id: zod_1.z.string(),
    at: zod_1.z.string(),
    type: zod_1.z.string(),
    product: zod_1.z.string(),
    rate: zod_1.z.string(),
    note: zod_1.z.string(),
})
    .strict();
exports.agricultureOpsCropHarvestRecordSchema = zod_1.z
    .object({
    id: zod_1.z.string(),
    season: zod_1.z.string(),
    yieldPerHa: zod_1.z.string(),
    revenue: zod_1.z.string(),
    note: zod_1.z.string(),
})
    .strict();
exports.agricultureOpsCropMarketEntrySchema = zod_1.z
    .object({
    id: zod_1.z.string(),
    buyer: zod_1.z.string(),
    initiative: zod_1.z.string(),
    quantity: zod_1.z.string(),
    price: zod_1.z.string(),
    status: zod_1.z.string(),
    note: zod_1.z.string(),
})
    .strict();
exports.agricultureOpsCropRecordSchema = zod_1.z
    .object({
    id: zod_1.z.string(),
    crop: zod_1.z.string(),
    field: zod_1.z.string(),
    area: zod_1.z.number(),
    stage: zod_1.z.string(),
    planted: zod_1.z.string(),
    harvestEst: zod_1.z.string(),
    yieldEst: zod_1.z.number(),
    pricePerTonne: zod_1.z.number(),
    status: zod_1.z.string(),
    variety: zod_1.z.string(),
    fieldManager: exports.agricultureOpsPersonSchema,
    description: zod_1.z.string(),
    healthMetrics: zod_1.z.array(exports.agricultureOpsMetricSchema),
    treatmentSummary: zod_1.z.array(exports.agricultureOpsMetricSchema),
    conditions: zod_1.z.array(exports.agricultureOpsCropConditionLogSchema),
    treatments: zod_1.z.array(exports.agricultureOpsCropTreatmentLogSchema),
    harvestRecords: zod_1.z.array(exports.agricultureOpsCropHarvestRecordSchema),
    marketEntries: zod_1.z.array(exports.agricultureOpsCropMarketEntrySchema),
    images: zod_1.z.array(zod_1.z.string()),
    timeline: zod_1.z.array(exports.agricultureOpsTimelineEntrySchema),
    comments: zod_1.z.array(exports.agricultureOpsCommentSchema),
    polygon: zod_1.z.array(exports.agricultureOpsMapPointSchema),
})
    .strict();
exports.agricultureOpsPoiRecordSchema = zod_1.z
    .object({
    id: zod_1.z.string(),
    name: zod_1.z.string(),
    type: zod_1.z.string(),
    lat: zod_1.z.number(),
    lng: zod_1.z.number(),
    notes: zod_1.z.string(),
    status: zod_1.z.string(),
    owner: exports.agricultureOpsPersonSchema,
    images: zod_1.z.array(zod_1.z.string()),
    linkedAssets: zod_1.z.array(zod_1.z.string()),
    metrics: zod_1.z.array(exports.agricultureOpsMetricSchema),
    alerts: zod_1.z.array(exports.agricultureOpsAlertSchema),
    history: zod_1.z.array(exports.agricultureOpsTimelineEntrySchema),
    comments: zod_1.z.array(exports.agricultureOpsCommentSchema),
})
    .strict();
exports.agricultureOpsWorkOrderTaskSchema = zod_1.z
    .object({
    t: zod_1.z.string(),
    done: zod_1.z.boolean(),
})
    .strict();
exports.agricultureOpsWorkOrderAttachmentSchema = zod_1.z
    .object({
    name: zod_1.z.string(),
    type: zod_1.z.string(),
    size: zod_1.z.string(),
    date: zod_1.z.string(),
})
    .strict();
exports.agricultureOpsWorkOrderActivitySchema = zod_1.z
    .object({
    action: zod_1.z.string(),
    by: zod_1.z.string(),
    date: zod_1.z.string(),
})
    .strict();
exports.agricultureOpsWorkOrderRecordSchema = zod_1.z
    .object({
    id: zod_1.z.string(),
    title: zod_1.z.string(),
    description: zod_1.z.string(),
    assignee: zod_1.z.string(),
    assigneeId: zod_1.z.string(),
    vehicleId: zod_1.z.string(),
    vehicle: zod_1.z.string(),
    priority: zod_1.z.string(),
    status: zod_1.z.string(),
    startDate: zod_1.z.string(),
    dueDate: zod_1.z.string(),
    endDate: zod_1.z.string(),
    projectId: zod_1.z.string(),
    geofence: zod_1.z.string(),
    geofenceArea: zod_1.z.number(),
    geofenceShape: zod_1.z.string(),
    geo: zod_1.z
        .object({
        lat: zod_1.z.number(),
        lng: zod_1.z.number(),
    })
        .strict(),
    workers: zod_1.z.array(zod_1.z.string()),
    tasks: zod_1.z.array(exports.agricultureOpsWorkOrderTaskSchema),
    attachments: zod_1.z.array(exports.agricultureOpsWorkOrderAttachmentSchema),
    activity: zod_1.z.array(exports.agricultureOpsWorkOrderActivitySchema),
    category: zod_1.z.string(),
    budget: zod_1.z.number(),
    estimatedHours: zod_1.z.number(),
    actualHours: zod_1.z.number(),
    livestockIds: zod_1.z.array(zod_1.z.string()),
    equipmentIds: zod_1.z.array(zod_1.z.string()),
    poiIds: zod_1.z.array(zod_1.z.string()),
    materials: zod_1.z.array(zod_1.z.string()),
    comments: zod_1.z.array(exports.agricultureOpsCommentSchema),
})
    .strict();
exports.agricultureOpsProjectMilestoneSchema = zod_1.z
    .object({
    id: zod_1.z.string(),
    title: zod_1.z.string(),
    status: zod_1.z.string(),
    dueDate: zod_1.z.string(),
})
    .strict();
exports.agricultureOpsProjectRiskSchema = zod_1.z
    .object({
    id: zod_1.z.string(),
    title: zod_1.z.string(),
    severity: zod_1.z.enum(["low", "medium", "high"]),
    mitigation: zod_1.z.string(),
})
    .strict();
exports.agricultureOpsProjectRecordSchema = zod_1.z
    .object({
    id: zod_1.z.string(),
    name: zod_1.z.string(),
    description: zod_1.z.string(),
    manager: zod_1.z.string(),
    managerId: zod_1.z.string(),
    status: zod_1.z.string(),
    startDate: zod_1.z.string(),
    endDate: zod_1.z.string(),
    budget: zod_1.z.number(),
    spent: zod_1.z.number(),
    woIds: zod_1.z.array(zod_1.z.string()),
    coordinates: zod_1.z
        .object({
        lat: zod_1.z.number(),
        lng: zod_1.z.number(),
    })
        .strict(),
    type: zod_1.z.string(),
    objectives: zod_1.z.array(zod_1.z.string()),
    milestones: zod_1.z.array(exports.agricultureOpsProjectMilestoneSchema),
    risks: zod_1.z.array(exports.agricultureOpsProjectRiskSchema),
    comments: zod_1.z.array(exports.agricultureOpsCommentSchema),
    timeline: zod_1.z.array(exports.agricultureOpsTimelineEntrySchema),
})
    .strict();
exports.agricultureOpsWorkerCertificationSchema = zod_1.z
    .object({
    id: zod_1.z.string(),
    name: zod_1.z.string(),
    issuedAt: zod_1.z.string(),
    expiresAt: zod_1.z.string(),
})
    .strict();
exports.agricultureOpsWorkerTrainingRecordSchema = zod_1.z
    .object({
    id: zod_1.z.string(),
    topic: zod_1.z.string(),
    provider: zod_1.z.string(),
    completedAt: zod_1.z.string(),
})
    .strict();
exports.agricultureOpsWorkerRecordSchema = zod_1.z
    .object({
    id: zod_1.z.string(),
    name: zod_1.z.string(),
    role: zod_1.z.string(),
    contact: zod_1.z.string(),
    availability: zod_1.z.string(),
    assignedWOs: zod_1.z.array(zod_1.z.string()),
    skills: zod_1.z.array(zod_1.z.string()),
    hourlyRate: zod_1.z.number(),
    joined: zod_1.z.string(),
    photoUrl: zod_1.z.string().nullable(),
    passportNumber: zod_1.z.string(),
    nationalId: zod_1.z.string(),
    dateOfBirth: zod_1.z.string(),
    address: zod_1.z.string(),
    emergencyContact: zod_1.z.string(),
    employmentType: zod_1.z.string(),
    department: zod_1.z.string(),
    supervisor: zod_1.z.string(),
    notes: zod_1.z.string(),
    qualifications: zod_1.z.array(zod_1.z.string()),
    certifications: zod_1.z.array(exports.agricultureOpsWorkerCertificationSchema),
    trainingRecords: zod_1.z.array(exports.agricultureOpsWorkerTrainingRecordSchema),
    comments: zod_1.z.array(exports.agricultureOpsCommentSchema),
    timeline: zod_1.z.array(exports.agricultureOpsTimelineEntrySchema),
})
    .strict();
exports.agricultureOpsTimesheetRecordSchema = zod_1.z
    .object({
    id: zod_1.z.string(),
    workerId: zod_1.z.string(),
    date: zod_1.z.string(),
    hours: zod_1.z.number(),
    woId: zod_1.z.string(),
    status: zod_1.z.string(),
})
    .strict();
exports.agricultureOpsReportDefinitionSchema = zod_1.z
    .object({
    id: zod_1.z.string(),
    name: zod_1.z.string(),
    description: zod_1.z.string(),
    module: zod_1.z.string(),
    delivery: zod_1.z.enum(["live", "preview"]),
    tags: zod_1.z.array(zod_1.z.string()),
    fields: zod_1.z.array(zod_1.z.string()),
    previewRows: zod_1.z.array(zod_1.z.record(zod_1.z.string(), zod_1.z.union([zod_1.z.string(), zod_1.z.number()]))),
})
    .strict();
exports.agricultureOpsReportCategorySchema = zod_1.z
    .object({
    id: zod_1.z.string(),
    name: zod_1.z.string(),
    description: zod_1.z.string(),
    reports: zod_1.z.array(exports.agricultureOpsReportDefinitionSchema),
})
    .strict();
exports.agricultureOpsWeatherSchema = zod_1.z
    .object({
    temp: zod_1.z.number(),
    condition: zod_1.z.string(),
    humidity: zod_1.z.number(),
    windSpeed: zod_1.z.number(),
    windDir: zod_1.z.string(),
    rainfall24h: zod_1.z.number(),
    forecast: zod_1.z.array(zod_1.z
        .object({
        day: zod_1.z.string(),
        temp: zod_1.z.number(),
        icon: zod_1.z.string(),
    })
        .strict()),
    soilMoisture: zod_1.z.array(zod_1.z
        .object({
        block: zod_1.z.string(),
        val: zod_1.z.number(),
        status: zod_1.z.string(),
    })
        .strict()),
})
    .strict();
exports.agricultureOpsBootstrapSchema = zod_1.z
    .object({
    livestock: zod_1.z.array(exports.agricultureOpsLivestockRecordSchema),
    equipment: zod_1.z.array(exports.agricultureOpsEquipmentRecordSchema),
    geofences: zod_1.z.array(exports.agricultureOpsGeofenceRecordSchema),
    crops: zod_1.z.array(exports.agricultureOpsCropRecordSchema),
    pois: zod_1.z.array(exports.agricultureOpsPoiRecordSchema),
    workOrders: zod_1.z.array(exports.agricultureOpsWorkOrderRecordSchema),
    projects: zod_1.z.array(exports.agricultureOpsProjectRecordSchema),
    workers: zod_1.z.array(exports.agricultureOpsWorkerRecordSchema),
    timesheets: zod_1.z.array(exports.agricultureOpsTimesheetRecordSchema),
    reports: zod_1.z.array(exports.agricultureOpsReportCategorySchema),
    weather: exports.agricultureOpsWeatherSchema,
})
    .strict();
exports.agricultureOpsEntityKeySchema = zod_1.z.enum([
    "livestock",
    "equipment",
    "geofences",
    "crops",
    "pois",
    "work-orders",
    "projects",
    "workers",
    "timesheets",
    "reports",
]);
